import React from 'react';
import { array } from 'prop-types';
import { connect } from 'react-redux';

import { orderBy } from 'lodash';

import TabPanel, { Tab, TabContent } from '../../components/TabPanel';
import ActionBar from '../../components/ActionBar';
import AreasTable from './AreasTable';
import WeatherDataInsert from './WeatherDataInsert';
import LinksTableAndSearch from './LinksTableAndSearch';

import * as ArchitectActions from '../../actions/architectActions';

import classes from './SiteDataInsert.module.css';

const SiteDataInsert = ({
    ...props
}) => {
    const handleSort = (props, property) => {
        return (event) => {
            props.reorderItems(property);
        };
    };

    const featureFlagForLinksTabs = () => {
        if (process.env.erpAgentEnabled) {
            return (
                <TabPanel
                    aria-label="Site Data Options"
                    classes={{
                        root: classes.tabPanel
                    }}
                >
                    <Tab title="Areas">
                        <TabContent
                            classes={{
                                root: classes.areaTabContent
                            }}
                        >
                            <ActionBar
                                onSearch={() => {}}
                            />
                            <div className={classes.scrollContainer}>
                                <AreasTable
                                    areas={props.areas}
                                    order={props.order}
                                    orderBy={props.orderBy}
                                    onSort={property => handleSort(props, property)}
                                />
                            </div>
                        </TabContent>
                    </Tab>
                    <Tab title="Weather">
                        <TabContent
                            classes={{
                                root: classes.areaTabContent
                            }}
                        >
                            <WeatherDataInsert onToggleWeatherDataModal={props.onToggleWeatherDataModal} />
                        </TabContent>
                    </Tab>
                    <Tab title="Links">
                        {process.env.erpAgentEnabled &&
                        <LinksTableAndSearch
                            order={props.order}
                            orderBy={props.orderBy}
                            handleSort={handleSort}
                            onToggleCreateLinkModal={props.onToggleCreateLinkModal}
                            onToggleDeleteLinkModal={props.onToggleDeleteLinkModal}
                            selectedNode={props.selectedNode}
                            links={props.links}
                        />}
                    </Tab>
                </TabPanel>
            );
        } else {
            return (
                <TabPanel
                    aria-label="Site Data Options"
                    classes={{
                        root: classes.tabPanel
                    }}
                >
                    <Tab title="Areas">
                        <TabContent
                            classes={{
                                root: classes.areaTabContent
                            }}
                        >
                            <ActionBar
                                onSearch={() => {}}
                            />
                            <div className={classes.scrollContainer}>
                                <AreasTable
                                    areas={props.areas}
                                    order={props.order}
                                    orderBy={props.orderBy}
                                    onSort={property => handleSort(props, property)}
                                />
                            </div>
                        </TabContent>
                    </Tab>
                    <Tab title="Weather">
                        <TabContent
                            classes={{
                                root: classes.areaTabContent
                            }}
                        >
                            <WeatherDataInsert onToggleWeatherDataModal={props.onToggleWeatherDataModal} />
                        </TabContent>
                    </Tab>
                </TabPanel>
            );
        }
    };

    return (
        <div className={classes.root}>
            {featureFlagForLinksTabs()}
        </div>
    );
};

SiteDataInsert.defaultProps = {
    links: []
};

SiteDataInsert.propTypes = {
    links: array
};

const mapStateToProps = state => {
    const {
        areas,
        order,
        links,
        orderBy: orderByKey
    } = state.architect;

    return {
        areas:   orderBy(areas, [orderByKey], order),
        links:   orderBy(links, [orderByKey], order),
        order,
        orderBy: orderByKey
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteDataInsert);
